var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"pt-0 mt-0 mx-1 input-id",staticStyle:{"max-width":"80px"},attrs:{"items":_vm.kindItems,"value":_vm.value,"disabled":"","hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("capitalize")(item)))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }